import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBSpinner
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getAutoAttendant } from "../apiclients/streamsapi_bridge";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import PopupLoader from "./popups/PopupLoader";
import AddAAGroup from "./popups/autoattendant/AddAAGroup";
import DeleteAAGroup from "./popups/autoattendant/DeleteAAGroup";
import { formattedNumber } from './popups/phonenumbers/AddRemoveNumbers';
import { Tooltip } from 'react-tooltip';
import PopupLoaderNew from './popups/PopupLoaderNew';
import { getAssocCFDataByEntityIdNodeType } from '../components/topviews/HuntGroups';
import { customSearch, useAutoFocusSearchAfterLoads } from '../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../apiclients/UIConstant';
import TabIDConstant from '../apiclients/TabIDConstant';
import ImportProgressWarning from '../apiclients/ImportProgressWarning';
import { getImpExpStatusNew } from '../apiclients/CommonUtils';
import ImpExpRedirectPopup from '../apiclients/ImpExpRedirectPopup';
import ImportUser from '../components/editviews/user/ImportUser';
function AutoAttendant(props) {
  const location = useLocation();
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  // const [addAAGroup, setAddAAGroup] = useState(location.state ? location.state.openadd : false);
  //const togglePopup = () => setAddAAGroup(!addHundGroup);

  const [basicModal1, setBasicModal1] = useState(false);
  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const [aagroups, setAAGroups] = useState([]);
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(true);
  const [deleteaagrp, setDeleteAAGrp] = useState(false);
  const [selectedgrp, setSelectedGrp] = useState();
  const [internalError, setInternalError] = useState(false);
  const dtogglePopup = () => setDeleteAAGrp(!deleteaagrp);
  const addAAGrpRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [AaGroupDetails, setAaGroupDetails] = useState([]);
  const [showExportWarning, setShowExportWarning] = useState(false);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
 
   useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
  function handleClick() {
    addAAGrpRef.current.click();
  }
  // const actionData = {
  //   columns: [
  //     { label: 'Name', field: 'name' },
  //     { label: 'Extension', field: 'position' },
  //     { label: 'Number', field: 'office' },
  //     { label: 'Remove', field: 'contact', sort: false },
  //   ],
  //   rows: [
  //     {
  //       name: 'Main Open AA',
  //       position: '5000',
  //       office: '543 863 9874',
  //       phone: ' ',
  //       email: 'tiger.nixon@gmail.com',
  //     },
  //     {
  //       name: 'Main Closed AA',
  //       position: '5005',
  //       office: ' ',
  //       phone: ' ',
  //       email: 'sfrost@gmail.com',
  //     },
  //     {
  //       name: 'Sales AA',
  //       position: '2000',
  //       office: '408 754 1447, 530 855 4900, 510 352 8700',
  //       phone: ' ',
  //       email: 'tfitz@gmail.com',
  //     },
  //   ].map((row) => {
  //     return {
  //       ...row,
  //       contact: (
  //         <>
  //           <div onClick={toggleShow1}>
  //             <img src={remove} className="close-icon" />
  //           </div>
  //         </>
  //       ),
  //     };
  //   }),
  // };
  async function fetchData() {
    sessionStorage.setItem("current_link", "autoattendant");
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getAutoAttendant(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      TabIDConstant.AUTO_ATTENDANT_LINK
    );
    const rawData = await response.json();
    if (response.status === 200) {
      setAAGroups(rawData.groups);
    } else if (response.status === 500) {
      setInternalError(true);
    } else {
      navigate("/");
    }
    setIsloading(false);
  }

  useEffect(() => {
    fetchData();

  }, [])

  async function deleteAAGroup(evntData, code) {
    evntData.preventDefault();
    evntData.stopPropagation();

    console.log("event data:: ");
    console.log(evntData);
    let selMember = aagroups.filter((tmdata) => tmdata.code == code)[0];
    
    setSelectedGrp(selMember);
     // fetching the associated CF information
     let associatedCF = await getAssocCFDataByEntityIdNodeType(JSON.parse(sessionStorage.getItem("admin_session")).siteid, code, 3 );
     setAssocCallFlows(associatedCF.associated_callflows);
     setDeleteAAGrp(true);
  }

useEffect(()=>{
  let processdrows = [];
  aagroups?.forEach((group) => {
    let phNumber = group.phnumber ? formattedNumber(group.phnumber) + "" : ""
    processdrows.push({
      name: group.title + "",
      extension: group.extensions + "",
      number: group?.phnumber_count > 1 ? phNumber + ", ...": phNumber,
      actualNumber: phNumber?.toString().replace(/[ ]/g, ''),
      location: group.location_name + "",
      number: group.phnumber + "" ?? "",
      delete:

        <>
          {/* <a
          style={{ zIndex: 99996 }}
          href="#"
          onClick={(e) => deleteAAGroup(e, `${group.code}`)}
          target="_new"
          >
          <MDBIcon fas icon="times" className="green ms-3 " title="Remove" />
        </a> */}
          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deleteAAGroup(e, `${group.code}`)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
    });
  });
  setFilteredRows(processdrows);
  setAaGroupDetails(processdrows)
      setDataLoaded(true);
  }, [aagroups])

  const basicData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Extension", field: "extension", sort: true },
      { label: "Numbers", field: "number", sort: true },
      { label: "Location", field: "location", sort: true },
      { label: "Remove", field: "delete", sort: false },

    ],
    rows: AaGroupDetails,
  };

  const handleManualSearch = (searchValue) =>{
    setSearchValue(searchValue); 
    const filtered = customSearch(AaGroupDetails, searchValue, UIConstant.AUTO_ATTENDANT);
  
    setFilteredRows(filtered);
  };

  function showThisInfo(tdata) {
    console.log(tdata);
    let selMember = aagroups.filter(
      (tmdata) => tmdata.extensions == tdata.extension
    )[0];
    console.log(selMember)
    navigate("/accinfo", {
      state: selMember,
    });
  }


  const [AddAutoAttendant, setAddAutoAttendant] = useState(location.state ? location.state.openadd : false);
  const toggleShow11 = () => setAddAutoAttendant(!AddAutoAttendant);
  useEffect(() =>{
    if (location.state?.openadd) {
      setAddAutoAttendant(true);
      navigate("/autoattendant", { replace: true, state: {} }); // Reset state immediately
    }
  }, [location.state]);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const handleImportAndPrgress = async(e) => {
      e.preventDefault();
      const result = await getImpExpStatusNew();
      if (result.status === 0) {
        toggleShow11();
      } else if (result.isOwnUser) {
        setShowImpExpRedirect(true);
      } else {
        const { userInfo } = result;
        if (userInfo?.isaccount) {
          setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
        } else {
          setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
        }
        exportwarningToggle();
      }
    }

  return (
    <React.Fragment>
      <>
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        <MainLinks active={2} />
        <Body tablinks={2}
          sublink={18}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="fw-600">{t("AutoAttendants")}</h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="mb-3 dblock">
                      <div className="d-flex justify-content-between flex-wrap">
                        {/* <div className="input-group btn-width-100 w-30">
                          <div className="form-outline">
                            <input type="text" className="form-control btn-width-100" id="datatable-search-input" value="" />
                            <label className="form-label" for="datatable-search-input">
                              {t('search')}
                            </label>
                          </div>
                        </div> */}
                      </div>
                      <div className="actionbar">
                        <MDBBtn className="" onClick={(e) => handleImportAndPrgress(e)}>
                          <MDBIcon fas icon="plus" size="sm" />  {t("addAutoAttendant")}
                        </MDBBtn>
                      </div>
                      <div className='mb-2 mt-0 position-relative w-auto'>
                        <MDBInput
                          label="Search"
                          ref={searchRef}
                          value={searchValue}
                          onChange={(e) => handleManualSearch(e.target.value)}
                        />
                        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                      </div>
                      <div className="w-100 aaDataTable">
                        <MDBDatatable className='actioncolumn'
                          onRowClick={(event, rowData) => {
                            showThisInfo(event);
                          }}
                          key={searchValue}
                          // search
                          fixedHeader
                          entries={50}
                          // maxHeight="63vh"
                          multi
                          // selectable
                          sortField="Name"
                          sortOrder="asc"
                          searchInputProps={[]}
                          data={{...basicData,rows:filteredRows}}
                          responsive
                          hover
                        />
                      </div>
                    </div>
                  </div>
                  {AddAutoAttendant && (
                    <PopupLoaderNew
                      title={"Add Auto-Attendant"}
                      content={<AddAAGroup 
                        onClose={toggleShow11} 
                        ref={addAAGrpRef}
                        setIsloading={setisLoading}
                      />}
                      onShow={setAddAutoAttendant}
                      onClose={toggleShow11}
                      onSave={handleClick}
                      isloading={isLoading}
                      flag={1}
                    />
                  )}
                </div>
              </section>
              {
                deleteaagrp && (
                  <PopupLoaderNew
                    title={"Remove Auto-Attendant Group"}
                    content={<DeleteAAGroup
                      group={selectedgrp}
                      onClose={dtogglePopup} 
                      ref={addAAGrpRef}
                      setIsloading={setisLoading}
                      assocCFData = {assocCallFlows}
                      />}
                    onShow={setDeleteAAGrp}
                    onClose={dtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={assocCallFlows.length == 0 ? 4 : 10}  
                    hideClose={assocCallFlows.length == 0 ? false : true}
                  />
                )
              }

              {showExportWarning && (
                <ImportProgressWarning
                  warningToggle={exportwarningToggle}
                  setShowWarning={setShowExportWarning}
                  onOk={exportwarningToggle}
                  message={warningMessage}
                />
              )}

              {showImpExpRedirect && (
                <ImpExpRedirectPopup
                  onProceed={() => {
                    setShowImpExpRedirect(false);
                    setfirstRequest(true);
                    importuserToggle();
                  }}
                  onCancel={() => setShowImpExpRedirect(false)}
                />
              )}

              <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
                <MDBModalDialog size="fullscreen">
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Import User Template</MDBModalTitle>
                    </MDBModalHeader>
                    <MDBModalBody className="pb-0">
                      <ImportUser
                        onClose={importuserToggle}
                        setIsloading={setisLoading}
                        onShow={setimportUser}
                        show={importUser}
                        firstRequest={firstRequest}
                        setfirstRequest={setfirstRequest}
                      />
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

            </>
          }
        />
        {/* <Footer /> */}

        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );
}

export default AutoAttendant;
